import type { MouseEvent } from 'react'
import { startTransition, useCallback, useState } from 'react'

export interface UseDialogReturn {
  readonly isOpen: boolean
  readonly open: (e?: MouseEvent) => void
  readonly close: () => void
}

export function useDialog(): UseDialogReturn {
  const [isOpen, setIsOpen] = useState(false)

  const open = useCallback((e?: MouseEvent) => {
    e?.stopPropagation()
    startTransition(() => {
      setIsOpen(true)
    })
  }, [])

  const close = useCallback(() => {
    startTransition(() => {
      setIsOpen(false)
    })
  }, [])

  return {
    isOpen,
    open,
    close,
  }
}
